import type {
  AccessChecker,
  NavLeaf,
  NavNode,
  PathBuilder,
  Translate,
} from './types';

import { CalendarDaysIcon } from '@valwin/facto/icons';

import { ROUTES } from '~shared/routes';

export function buildCalendarItem(
  buildPath: PathBuilder,
  t: Translate,
  checkAccess: AccessChecker,
  isAdmin: boolean
): NavNode {
  const hasCommunicationBrick = checkAccess({
    isAdmin,
    requiredFeatures: ['COMMUNICATION_BRICK'],
  });
  const hasAssetsManagement = checkAccess({
    isAdmin,
    requiredFeatures: ['GROUP_ASSETS_MANAGEMENT'],
  });

  if (!hasCommunicationBrick && !hasAssetsManagement) {
    return {
      kind: 'link',
      id: 'calendar',
      label: t('menu animateSites'),
      icon: CalendarDaysIcon,
      to: buildPath(ROUTES.calendar),
    };
  }

  const children: NavLeaf[] = [
    {
      kind: 'link',
      id: 'calendar',
      label: t('menu createContent'),
      to: buildPath(ROUTES.calendar),
    },
  ];

  if (hasCommunicationBrick) {
    children.push({
      kind: 'link',
      id: 'communication',
      label: t('menu suggestContent'),
      to: buildPath(ROUTES.communication),
    });
  }

  if (hasAssetsManagement) {
    children.push({
      kind: 'link',
      id: 'static-content',
      label: t('menu staticContent'),
      to: buildPath(ROUTES.staticContents),
    });
  }

  return {
    kind: 'group',
    id: 'animate-sites',
    label: t('menu animateSites'),
    icon: CalendarDaysIcon,
    children,
  };
}
